export default __webpack_public_path__ + "static/media/final.a1e81938.wav";